import React, {useEffect, useState} from 'react';
import {useUsers} from "hooks/Users/useUsers";
import {connect} from 'react-redux';
import FilterCheckBox from '../FilterCheckBox';
import FilterPopover from "../FilterPopover";
import {Button} from "ui";
import {FormattedMessage} from "react-intl";

type FilterDataMap = Record<string, unknown>;

interface DepartmentsFilterInterface {
    tagBuilder: Function;
    session?: any;
    customers: string[];
    setDepartments: React.Dispatch<React.SetStateAction<string[]>>;
    setFilterValues: any;
    filterValues: any
    form: any;
    filterKey: string;
    setFilterKey: React.Dispatch<React.SetStateAction<string>>;
}

const mapStateToProps = (state: any) => {
    return {
        session: state.session
    }
};

const DepartmentsFilter: React.FC<DepartmentsFilterInterface> = ({
                                                                     filterKey,
                                                                     setFilterKey,
                                                                     form,
                                                                     setDepartments,
                                                                     tagBuilder,
                                                                     session,
                                                                     customers,
                                                                     setFilterValues,
                                                                     filterValues
                                                                 }) => {
    const {getDepartments, loading} = useUsers()
    const [data, setData] = useState<FilterDataMap>({});
    const [initialValues, setInitialValues] = useState(undefined)

    const key = 'departments'

    const onSearch = async (value: string = '') => {
        const response = await getDepartments(value, session, customers);
        const safeResponse: FilterDataMap =
            response && typeof response === 'object' && !Array.isArray(response) ? response : {};
        setData(safeResponse);

        setFilterValues(
            {
                ...filterValues,
                departments: {
                    ...filterValues.departments,
                    ...safeResponse
                }
            }
        )
    };

    useEffect(() => {
        onSearch()
    }, []);

    useEffect(() => {
        onSearch()
    },[customers])

    const content = (
        <>
            <FilterCheckBox setData={setDepartments} data={data} name={'departments'} onSearch={onSearch}/>
            <div className={'flex justify-between p-1'}>
                <Button type={'link'} onClick={() => handleClose()} message='general.cancel' />
                <Button type={'primary'} onClick={() => {setFilterKey(''); handleOpen(false);}} message='general.select' />
            </div>
        </>
    );

    const handleClose = () => {form.setFieldsValue(initialValues); setFilterKey('');}

    const handleOpen = (open: boolean) => {
        if (open) {
            setInitialValues(form.getFieldsValue())
            setFilterValues(
                {
                    ...filterValues,
                    departments: {
                        ...filterValues.departments,
                        ...data
                    }
                }
            )
        } else {
            tagBuilder()
        }
    }

    return (
        <FilterPopover
            popoverKey={key}
            filterKey={filterKey}
            setOpen={setFilterKey}
            handleOpen={handleOpen}
            content={content}
            loading={loading}
            title={'general.search_by_department'}
            buttonTitle={'general.departments'}
        />
    );
};

export default connect(mapStateToProps)(DepartmentsFilter);